import React, { Fragment } from 'react';

import Grid from '@material-ui/core/Grid';

import BaseRecordItem, { TimeInfo, Notes } from './_BaseRecordItem';

import { unitForType } from '../EditForms/Measurement';

export default ({ record, topic, showNotes, ...rest }) => {
  const { start, type, quantity, notes } = record.data;

  const blurb = (
    <Fragment>
      <Grid container component="span" justify="space-between">
        <Grid item component="span">
          <TimeInfo start={start} end={null} />
        </Grid>
        <Grid item component="span">
          {
            [
              type,
              quantity ? `${quantity}${unitForType(type)}` : null,
              !showNotes && notes && '*',
            ].filter(Boolean).join(' ')
          }
        </Grid>
      </Grid>
      { showNotes && <Notes notes={notes} /> }
    </Fragment>
  );

  return (
    <BaseRecordItem topic={topic} blurb={blurb} {...rest} />
  );
}
